import { useCallback } from 'react'
import { useWarehouse } from '@/context/WarehouseContext'
import { appendWarehouseQueryParam } from './config'

export const useWarehouseScopedUrl = () => {
  const { selectedWarehouseId } = useWarehouse()

  return useCallback(
    (path: string): string => appendWarehouseQueryParam(path, selectedWarehouseId),
    [selectedWarehouseId]
  )
}
